/**
 * Persists last-known Total Connect work-email / mailbox access snapshot on TotalAccessOfflineDB
 * (`emails` domain opaque meta via `emailUiCacheStore`) so `useWorkEmail` can hydrate instantly
 * before the network round-trip (Capacitor, desktop, and web portal).
 */
import type { WorkEmailAccount } from '@/hooks/useWorkEmail';
import { emailUiCacheStore } from '@/lib/offline/emailUiCacheStore';

const SEGMENT = 'work_email_access' as const;

export interface CachedWorkEmailAccessPayload {
  workEmail: WorkEmailAccount | null;
  cachedAt: string;
}

export async function readCachedWorkEmailAccess(
  clientId: number,
): Promise<CachedWorkEmailAccessPayload | undefined> {
  if (!clientId) {
    return undefined;
  }
  return emailUiCacheStore.getOpaqueMeta<CachedWorkEmailAccessPayload>(clientId, SEGMENT);
}

export async function writeCachedWorkEmailAccess(
  clientId: number,
  workEmail: WorkEmailAccount | null,
): Promise<void> {
  if (!clientId) {
    return;
  }
  await emailUiCacheStore.setOpaqueMeta(clientId, SEGMENT, {
    workEmail,
    cachedAt: new Date().toISOString(),
  });
}
